export default __webpack_public_path__ + "static/media/2013.36e7b0ab.png";